import $ from "jquery";

import {
    //getAITracking,
    getAllAnnotationsDB,
    getAnnotationsDB, removeAllAnnotationsDB,

    setAnnotationDB,
    //saveAITracking
} from "../Database/AnnotationsDAO";
import {removeLVDocumentDB, setLVDocumentDB} from "../Database/lvDocumentDAO";
import {removeAnnotation} from "../API/annotatorApi";
import { v4 } from 'uuid';
//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
//let apilink  = "http://0.0.0.0:60/"

export function remove(range, ranges) {
    if (!ranges || !ranges.size) {
        return ranges;
    }
    const immutableRange = ranges.find(
        (r) =>
            r.data.id === range.data.id &&
            r.start === range.start &&
            r.end === range.end
    );
    const index = ranges.indexOf(immutableRange);

    return ranges.remove(index);
}

export async function getLastSelectedAdvice() {
    // Retrieve Annotation ID of last annotation
    let lastAnnotationID = localStorage.getItem("lastAnnotationID");

    if (lastAnnotationID !== "" && lastAnnotationID !== null) {
        // Retrieve Last Annotation Data
        let lastAnnotation = await getAnnotationsDB(lastAnnotationID).then(
            function (result) {
                return JSON.stringify(result);
            }
        );
        lastAnnotation = JSON.parse(lastAnnotation);

        // Update New Annotation with Last Annotation Data
        let newAnnotationID = localStorage.getItem("annotationID");

        // Retrieve New Annotation Data
        let newAnnotation = await getAnnotationsDB(newAnnotationID).then(function (
            result
        ) {
            return JSON.stringify(result);
        });

        newAnnotation = JSON.parse(newAnnotation);

        newAnnotation.map(async (newAnnotationV) => {
            // Populating data
            newAnnotationV.annotation_data.ord =
                lastAnnotation[0].annotation_data.ord;
            newAnnotationV.annotation_data.kommentor =
                lastAnnotation[0].annotation_data.kommentor;
            newAnnotationV.annotation_data.norm =
                lastAnnotation[0].annotation_data.norm;
            newAnnotationV.annotation_data.advice =
                lastAnnotation[0].annotation_data.advice;
            newAnnotationV.annotation_data.formula =
                lastAnnotation[0].annotation_data.formula;
            newAnnotationV.annotation_data.adviceID =
                lastAnnotation[0].annotation_data.adviceID;
            newAnnotationV.annotation_data.type =
                lastAnnotation[0].annotation_data.type;
            newAnnotationV.annotation_data.law =
                lastAnnotation[0].annotation_data.law;

            // Populating the Annotator form Component
            $("#norm").val(newAnnotationV.annotation_data.norm);
            $("#advice").val(newAnnotationV.annotation_data.advice);
            $("#agl").val(newAnnotationV.annotation_data.law);
            $("#kommentor").val(newAnnotationV.annotation_data.kommentor);
            $("#category").val(newAnnotationV.annotation_data.type);
            $("#ursache").val(newAnnotationV.annotation_data.Annotation);

            // Adapting Values - Insertion Possibility

            // Hinweis has no value, so Calculation UI in Annotator UI needs to be read only
            // and default value set to zero.
            if (newAnnotationV.annotation_data.type === "Hinweis") {
                $("#kalkulationValue")
                    .val("Hinweis hat kein Wert!")
                    .attr("readonly", true);
                $("#kalkulationTotalValue").val("0");

                //Update values for change advice
                newAnnotationV.annotation_data.value = "";
            } else {
                $("#kalkulationValue")
                    .val(newAnnotationV.annotation_data.mengeUnitValue)
                    .attr("readonly", false);
                $("#kalkulationTotalValue").val(newAnnotationV.annotation_data.value);
            }

            // Add colour to annotation on UI
            let adviceCategory = newAnnotationV.annotation_data.type;
            let adviceCategoryColor;

            switch (adviceCategory) {
                case "Potenzial":
                    adviceCategoryColor = "rgb(5, 165, 107)";
                    break;

                case "Risiko":
                    adviceCategoryColor = "rgb(239, 3, 3)";
                    break;

                case "Hinweis":
                    adviceCategoryColor = "rgb(231, 185, 20)";
                    break;

                default:
                    adviceCategoryColor = "rgb(82, 125, 219)";
            }

            document.getElementById(newAnnotationID).style.backgroundColor =
                adviceCategoryColor;

            // Set the updated state of the annotation
            setAnnotationDB(newAnnotationV.annotation_data);

            // set the lv document
            let lvDocument = await getCurrentStateOfLvDocument();
            removeLVDocumentDB();
            setLVDocumentDB(lvDocument);

            // Save Annotations via API
            //await saveAnnotations(await allAnnotations())
        });
    } else {
        alert("At least do 2 Annotation, before using the last advice feature.");
    }
}



export function cleared() {
    if (document.getElementById("form-id") != null) {
        $("#ursache").val("");
        $("#norm").val("");
        $("#agl").val("");
        $("#advice").val("");
        $("#kommentor").val("");
        $("#anspruch").val("");
        $("#formel").val("");
        $("#kalkulationValue").val("");
        $("#kalkulationTotalValue").val("");
    }
}

/**
 * A function that takes a JSON and a key name by which new cluster has to be produced.
 * @param json
 * @param key
 * @returns json
 */
export function clusterBy(json, key) {
    //console.log(json)
    return json.reduce(function (arrayOfObjects, obj) {
        arrayOfObjects[obj[key]] = arrayOfObjects[obj[key]] || [];
        arrayOfObjects[obj[key]].push(obj);
        return arrayOfObjects;
    }, {});
}

/***
 * This function gets the current innerHTML state of the lv document as string
 * @returns {string} innerHTML of LV document
 */
export async function getCurrentStateOfLvDocument() {
    let positionTexts = [];
    document.querySelectorAll("p[id]").forEach(function (p) {
        let elemID = p.id;
        if (
            document.getElementById(elemID) !== null &&
            document.getElementById(elemID).innerHTML.includes("</mark>") !== false
        ) {
            let text = document.getElementById(elemID).innerHTML;
            positionTexts.push({pText: text, id: elemID});
        }
    });
    return positionTexts;
}

/***
 * This function gets the current innerHTML state of the lv document as string
 * @returns {string} innerHTML of LV document
 */
export function getPositions() {
    let positionTexts = [];
    document.querySelectorAll("p[id]").forEach(function (p) {
        let elemID = p.id;
        if (
            document.getElementById(elemID) !== null
        ) {
            let text = document.getElementById(elemID).innerHTML;
            positionTexts.push({pText: text, id: elemID});
        }
    });
    return JSON.stringify(positionTexts);
}

/***
 * This function find the annotation with annotation ID and populate the annotation component.
 * @param annotationID
 */
export async function populateAnnotationComponent(annotationID) {
    let annotationsGet = await getAnnotationsDB(annotationID).then(function (
        result
    ) {
        return JSON.stringify(result);
    });

    annotationsGet = JSON.parse(annotationsGet);

    annotationsGet.map((annotationsGetS) => {
        //Clear HTML Tags for display on UI
        let kommentor = clearHTML(annotationsGetS.annotation_data.kommentor);
        let norm = clearHTML(annotationsGetS.annotation_data.norm);
        let advice = clearHTML(annotationsGetS.annotation_data.advice);
        let formula = clearHTML(annotationsGetS.annotation_data.formula);

        //Clear nbsp - No-Break SPace
        kommentor = clearNBSP(kommentor);
        norm = clearNBSP(norm);
        advice = clearNBSP(advice);
        formula = clearNBSP(formula);

        // Populating the annotator form component

        if (annotationsGetS.annotation_data.norm !== "") {
            $("#norm").val(norm);
        }

        if (annotationsGetS.annotation_data.advice !== "") {
            $("#advice").val(advice);
        }

        if (annotationsGetS.annotation_data.law !== "") {
            $("#agl").val(annotationsGetS.annotation_data.law);
        }

        if (annotationsGetS.annotation_data.kommentor !== "") {
            $("#kommentor").val(kommentor);
        }

        $("#category").val(annotationsGetS.annotation_data.type);

        if (annotationsGetS.annotation_data.formula !== "") {
            $("#formel").val(formula);
        }

        $("#ursache").val(annotationsGetS.annotation_data.Annotation);
        if (annotationsGetS.annotation_data.type === "Hinweis") {
            $("#kalkulationValue").val("").attr("readonly", true);
            $("#kalkulationTotalValue").val("0");
        } else {
            $("#kalkulationTotalValue")
                .val(annotationsGetS.annotation_data.mengeUnitValue)
                .attr("readonly", false);
            $("#kalkulationTotalValue").val(annotationsGetS.annotation_data.value);
        }
    });
}

export function setAnnotationStale(annotationID) {
    if (
        annotationID !== undefined &&
        document.getElementById(annotationID) !== null
    ) {
        let staleMark = document.getElementById(annotationID);
        staleMark.style.animation = "fading 2s infinite";
    }
}

export function allAnnotations() {
    return getAllAnnotationsDB().then(function (result) {
        return JSON.stringify(result);
    });
}

/**
 * This function deletes an annotation given an annotation ID (for both löschen and delete from summary)
 */
export const removingAnnotation = async (selectedAnnotationID, state, lvID) => {
    let mark = document.getElementById(selectedAnnotationID);

    if (mark != null) {
        let nodes = mark.childNodes;
        if (nodes.length === 2) {
            mark.removeChild(mark.firstElementChild);
            $("#" + selectedAnnotationID)
                .contents()
                .unwrap();
        } else {
            $("#" + selectedAnnotationID)
                .contents()
                .unwrap();
        }

        cleared();

        const foundObject = state.annotations.find((obj) => obj.unique_id === selectedAnnotationID);
        if (foundObject) {
            let unique_id = foundObject.unique_id;
            let rowId = foundObject.rowId;

            let pText = document.getElementById(rowId.toString()).innerHTML;
            await removeAnnotation(lvID, unique_id, rowId.toString(), pText);
        }

        // Call the function to remove unlinked marks
        // Get all mark elements
        const marks = document.querySelectorAll('mark');

        // Iterate over each mark element
        marks.forEach(mark => {
            // Get the unique_id from the id attribute of the mark element
            const markUniqueId = mark.getAttribute('id');

            // Check if the unique_id is not present in the state annotations
            const isAnnotationPresent = state.annotations.some(annotation => annotation.unique_id === markUniqueId);

            // If the unique_id is not present in the state annotations, remove the mark element from the DOM
            if (!isAnnotationPresent) {
                mark.parentNode.replaceChild(document.createTextNode(mark.textContent), mark);
            }
        });
    }
};


/***
 * Endpoint function to initiate the brand identification
 * @returns {Promise<any>} Server response
 * @param parsedData
 */
// export async function invokeAnalyseEndpoint(lv_id) {
//     return fetch(
//         `${process.env.REACT_APP_BASE_URI}/api/handler/v2/resources/pipeline`,
//         {
//             method: "POST",
//             headers: {
//                 "Content-type": "application/json; charset=UTF-8",
//                 Authorization: "Bearer " + getToken(),
//             },
//             body: JSON.stringify({lv_id: lv_id}),
//         }
//     )
//         .then((response) => response.json())
//         .catch((error) => error);
// }





export async function invokeAnalyseEndpoint(parsedData) {
    console.log(123,parsedData)
    let data = parsedData?.data.OZ;
    let hinweisData = parsedData?.data.hinweisText
    let filtered = data.filter(item => !(item.type === 'Item' && item.hashRef !== false));
    let input = {"data":{"OZ": filtered, "hinweisText": hinweisData}}
    //alert(input, "filtered")

    return fetch(
        `${process.env.REACT_APP_BASE_URI}/pipeline`,
        {
            method: "POST",
            headers: {
                "Content-type": "application/json",

                //Authorization: "Bearer " + getToken(),
            },
            body: JSON.stringify({"lv_id": parsedData.data.parsedlv_id, "parserresult": input}),
        }
    )
        .then((response) => response.text())
        .catch((error) => error);
}

export async function invokeLabellingEndpoint(parsedData) {
    let data = parsedData?.data.OZ;
    let filtered = data.filter(item => item.long_text != null && item.long_text !== "");
    let input = filtered.map(item => {
        let hinweis_text = typeof(item.hinweis) === 'string' ? item.hinweis.trim() : item.hinweis[0].trim();
        let input_text = item.long_text;
        if (!input_text.startsWith(hinweis_text)) {
            input_text = hinweis_text + "\n" + input_text
        }
        return {
            row_id: item.row_id,
            type: item.type,
            text: input_text
        }
    })

    return fetch(
        `${process.env.REACT_APP_BASE_URI}/labelling_pipeline`,
        {
            method: "POST",
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify({"lv_id": parsedData.data.parsedlv_id, "data": input}),
        }
    )
        .then((response) => response.text())
        .catch((error) => error);
}

/**
 * Function to clear html tags in given data.
 * @param data
 * @returns data - no html tags
 */
export function clearHTML(data) {
    return data.replace(/<[^>]{1,10}>/gi, ""); // bounded quantifiers to 10 - example: blockquote
}

/**
 * Function to clear No-Break SPace (NBSP) in given data.
 * @param data
 * @returns data - replace nbsp with single space
 */
export function clearNBSP(data) {
    return data.replace(/&nbsp;/gi, " ");
}

/**
 * Function to save the annotations with validation
 * @returns {Promise<void>}
 */


// /***
//  * Endpoint function to initiate the brand identification
//  * @param lv_id: str
//  * @returns {Promise<any>} Server response
//  */
// export async function finalize_pipeline(lv_id) {
//
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/handler/v2/resources/finalize`, {
//         method: 'POST',
//         headers: {"Content-type": "application/json; charset=UTF-8", 'Authorization': 'Bearer ' + getToken()},
//         body: JSON.stringify({'lv_id': lv_id})
//     }).then(response => response.json())
//         .catch((error) => error);
// }


// /***
//  * Endpoint function to initiate the brand identification
//  * @param lv_id: str
//  * @returns {Promise<any>} Server response
//  */
// export async function finalize_pipeline(lv_id) {
//
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/handler/v2/resources/finalize`, {
//         method: 'POST',
//         headers: {"Content-type": "application/json",
//               //  "charset=UTF-8",
//             //'Authorization': 'Bearer ' + getToken()
//                 },
//         body: JSON.stringify({'lv_id': lv_id})
//     }).then(response => response.json())
//         .catch((error) => error);
// }

/***
 * Endpoint function to initiate the brand identification
 * @param project: object
 * @returns {Promise<any>} Server response
 */
export async function finalize_pipeline(lv_id) {

    return fetch(`${process.env.REACT_APP_BASE_URI}/finalize`, {
        method: 'POST',
        headers: {
            "Content-type": "application/json",
            //  "charset=UTF-8",
            //'Authorization': 'Bearer ' + getToken()
        },
        body: JSON.stringify({'lv_id': lv_id})
    }).then(response => response.json())
        .catch((error) => error);
}


/***
 * The function is used for deleting the all unwanted annotations for which we dont want to select an advice.
 * Especially helpful in the case of AI to ignore not needed ones.
 */
export const validateAnnotations = async () => {
    let annotationsGet = await getAllAnnotationsDB().then(function (result) {
        return JSON.stringify(result);
    });

    let annotations = JSON.parse(annotationsGet);
    let updated = annotations.filter(
        (obj) => obj.annotation_data.adviceID !== "1"
    );
    let marks = document.getElementsByClassName("entity");
    // Also removing its child element (span)
    for (let mark of marks) {
        mark.removeChild(mark.firstElementChild);
    }
    // Unwrap the contents of html elements such as mark and divs
    $(".entity").contents().unwrap();
    $(".entities").contents().unwrap();

    // Set the updated state of the annotations
    removeAllAnnotationsDB();
    for (let annotation of updated) {
        setAnnotationDB(annotation.annotation_data);
    }
    // Set the lv document
    let lvDocument = getCurrentStateOfLvDocument();
    removeLVDocumentDB();
    setLVDocumentDB(lvDocument);
};

export function updatePTextById(array, idToFind, newPText) {
    // Find the object with the matching id
    const objectToUpdate = array.find((obj) => obj.id === idToFind);

    // If the object with the specified id exists in the array
    if (objectToUpdate) {
        // Update the pText property of the object with the new text
        objectToUpdate.pText = newPText;
    }
    return array
}

export function updateHTML(html, oldID, newID){
        // Create a DOMParser instance
        const parser = new DOMParser();

        // Parse the HTML string
        let doc = parser.parseFromString(html, 'text/html');

        // Find the mark element
        console.log(oldID, "old id")
        let markElement = doc.getElementById(oldID);

        // Update the id attribute
        if(markElement){
            markElement.setAttribute('id', newID);
        } else {
            console.log("element not existed")
        }


        console.log(doc.documentElement.outerHTML, "Outerhtml")

        // Convert the updated DOM back to an HTML string
        return doc.documentElement.outerHTML;

    }

export function createUpdates(filteredAnnotationsByRowId, targetLvPositionAttributes, pText) {
      let annots = [];
      let html = pText
      let n = 0;

      for (let item = 0; item < filteredAnnotationsByRowId.length; item++) {
        let oldID = filteredAnnotationsByRowId[item].unique_id;
        let newID = v4();

        // Create a new object and copy attributes from the original object
        let updatedAnnotation = {
          ...filteredAnnotationsByRowId[item],
          rowId: targetLvPositionAttributes.rowId,
          ord: targetLvPositionAttributes.ord,
          short_text: targetLvPositionAttributes.short_text,
          unique_id: newID,
        };

        html = updateHTML(html, oldID, newID);

        annots.push(updatedAnnotation);

        n = n + 1;
        console.log(newID, "newID" + n.toString());
      }

      console.log(html, "updated HTML");
      return { targetAnnotations: annots, targetLvDocument: html };
}
